import { render, staticRenderFns } from "./ChargebackTypeForm.vue?vue&type=template&id=4d2e313b&"
import script from "./ChargebackTypeForm.vue?vue&type=script&lang=js&"
export * from "./ChargebackTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports